export const YOUTUBE_URL = process.env.REACT_APP_YOUTUBE_URL || '';
